import * as React from 'react';

const SvgRatingVeryHappyAlt = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M7.5 9.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM16.5 9.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM5.68 13c.68 2.87 3.25 5 6.32 5 3.07 0 5.64-2.13 6.32-5H5.68Z" })
);

export { SvgRatingVeryHappyAlt as default };
//# sourceMappingURL=RatingVeryHappyAlt.es.js.map
